export default __webpack_public_path__ + "static/media/unassignMatch.bf70306b.svg";